/**
 * Componente que muestra de forma compacta al solicitante del ticket.
 * * **Funcionalidades**:
 * - Muestra el avatar del usuario con un fallback a una imagen por defecto (`/default-avatar.png`).
 * - Renderiza el nombre completo (nombre y apellido) del solicitante, truncado si es largo.
 * * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.user - Objeto con la información del usuario solicitante.
 * @param {string} [props.user.photo] - URL de la fotografía de perfil.
 * @param {string} [props.user.nombre] - Nombre del usuario.
 * @param {string} [props.user.apellido] - Apellido del usuario.
 * * @returns {JSX.Element} Avatar pequeño con el nombre del solicitante.
 */
const TicketAuthorCard = ({ user }) => {
  return (
    <div className="vt-person">
      <span className="vt-avatar">
        <img src={user?.photo || '/default-avatar.png'} alt="avatar" />
      </span>
      <span className="vt-person-name">
        {user?.nombre ? `${user.nombre} ${user.apellido || ''}` : '—'}
      </span>
    </div>
  )
}

export default TicketAuthorCard
